import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { HelperService, MealPlanService, OrganizationService, SupplementProtocolService } from 'src/app/services';
import { IMeal, Organization, SupplementCategory, SupplementProtocol,} from 'src/app/models';

@Component({
  selector: 'app-supplement-category-select',
  templateUrl: './supplement-category-select.component.html',
  styleUrls: ['./supplement-category-select.component.scss'],
})
export class SupplementCategorySelectComponent implements OnInit {

  public categories: SupplementCategory[] = [];
  public organization: Organization;
  public searchTerm = "";

  constructor(
    private modalCtrl: ModalController,
    private organizationService: OrganizationService,
    private supplementProtocolService: SupplementProtocolService,
    private helperService: HelperService,
  ) { 
    this.organization = this.organizationService.getAppOrganization();
  }

  async ngOnInit() {
    this.supplementProtocolService.getOrganizationSupplementCategoriesAsPromise(this.organization.uid).then((categories) => {
      this.categories.push(...categories);
    });
  }

  getFilteredCategories() {
    let filteredCategories = [];
    for (const category of this.categories) {
      if(!this.searchTerm) {
        filteredCategories.push(category);
      } else {
        if(category.title.toLowerCase().indexOf(this.searchTerm.toLowerCase()) > -1) {
          filteredCategories.push(category);
        }
      }
    }
    return filteredCategories.sort((a,b) => {
      return a.title.localeCompare(b.title);
    });
  }

  selectCategory(category) {
    this.modalCtrl.dismiss({ status: "selected", data: this.helperService.copyObject(category) }, "selected");
  }

  cancel() {
    this.modalCtrl.dismiss({ status: "canceled" });
  }
}
